import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.White};
  }
`;
